



































import { Component, Vue, Prop } from "vue-property-decorator";
import Modal from "@/components/common/Modal.vue";
import BeatLoader from "vue-spinner/src/BeatLoader.vue";
import { validateNotEmpty } from "@/utils/form-validation";
import MainButton from "../common/MainButton.vue";
import { axios } from "@/utils/axios";

@Component({
  components: {
    Modal,
    BeatLoader,
    MainButton,
  },
})
export default class ModalUnlockCareerPath extends Vue {
  @Prop()
  careerPathUuid: string;

  width = "700px";
  title = "Nak Lihat Kerjaya Ni? Jom Request!";
  description = `Nak explore kerjaya ni? Masukkan nombor telefon korang, dan kami akan unlock kerjaya ni untuk korang!`;
  buttonTitle = "Unlock Pekerjaan";

  isLoading = false;
  showUnlockCareerModal = false;

  phoneNumber = "";
  hasError: string | boolean = false;

  toggleUnlockCareerModal(toggle: boolean, isCareerPath = true) {
    if (isCareerPath) {
      this.title = "Nak Lihat Kerjaya Ni? Jom Request!";
      this.description = `Nak explore kerjaya ni? Masukkan nombor telefon korang, dan kami akan unlock kerjaya ni untuk korang!`;
      this.buttonTitle = "Unlock Pekerjaan";
    } else {
      this.title = "Nak Lihat gaji Ni? Jom Request!";
      this.description = `Nak explore gaji ni? Masukkan nombor telefon korang, dan kami akan unlock gaji ni untuk korang!`;
      this.buttonTitle = "Unlock gaji";
    }
    this.showUnlockCareerModal = toggle;
  }

  async addCollectionSubmitted() {
    if (this.isLoading) return;
    this.isLoading = true;

    if (!validateNotEmpty(this.phoneNumber)) {
      this.hasError = "Phone number tidak boleh kosong";
      this.isLoading = false;
      return;
    } else {
      this.hasError = "";
    }

    if (!this.careerPathUuid) {
      this.hasError = "Something wrong, please whatsapp +601159951420";
      this.isLoading = false;
      return;
    } else {
      this.hasError = "";
    }

    this.$sendMpEvent({
      event: this.$mp_value.CareerPath_full_access,
    });

    try {
      const { data } = await axios.post(`/add-on/career-path/full-access`, {
        phoneNumber: this.phoneNumber,
        jobUuid: this.careerPathUuid,
      });

      if (data) {
        this.phoneNumber = "";
        this.toggleUnlockCareerModal(false);
        this.$toasted.global.mainToast({
          message: "Permintaan berjaya dihantar",
        });
      }
    } catch (error) {
      this.$toasted.global.mainToast({
        message: error,
      });
    }

    this.isLoading = false;
  }
}
